import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Creators } from 'store/ducks/user';

import Styles from './Landing.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';

import LoginBar from './LoginBar/LoginBar';
import MobileLoginBar from './MobileLoginBar/MobileLoginBar';
import { Divider, Button, Loading } from 'components/Template';

export default function LandingPage() {
  const dispatch = useDispatch();
  const [form, setForm] = useState({ email: '', password: '' });
  const loading = useSelector(state => state.user.auth.loading);
  const auth = useSelector(state => state.user.auth.error);
  const expired = useSelector(state => state.user.auth.expired);
  const [mobileLoginDiv, mobileLoginTrigger] = useState(false);

  function inputChangeHandler(e) {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  }

  function loginClickHandler(e) {
    e.preventDefault();
    dispatch(Creators.authenticate(form.email, form.password));
  }

  useEffect(() => {
    dispatch(Creators.clear());
  }, [form, dispatch]);

  return (
    <div className={Styles.landingPage}>
      <Loading open={loading} />
      <div style={{ display: 'block' }}>
        <LoginBar
          email={form.email}
          password={form.password}
          inputChangeHandler={inputChangeHandler}
          submitHandler={loginClickHandler}
          mobileLoginTrigger={mobileLoginTrigger}
          authError={String(
            expired
              ? 'A sessão expirou, por favor realize o login novamente.'
              : auth || '',
          )}
        />
        <MobileLoginBar
          email={form.email}
          password={form.password}
          inputChangeHandler={inputChangeHandler}
          submitHandler={loginClickHandler}
          setOpen={mobileLoginTrigger}
          open={mobileLoginDiv}
          authError={String(auth || '')}
        />
      </div>
      <section className={Styles.mainSection}>
        <h1>ALIMENTE SEU CULTIVO COM TECNOLOGIA</h1>
        <Divider className={Styles.divider} />
        <p>
          Nós podemos potencializar a sua performance no campo. Conheça os
          benefícios e funcionalidades da <strong>PEM</strong> - Posicionamento
          Estratégico de Mercado
        </p>
      </section>
      <section className={Styles.nosTemosSection}>
        <h3>Temos o que você precisa!</h3>
        <Divider className={Styles.divider} />
        <p>
          A PEM - Posicionamento Estratégico de Mercado - foi desenvolvida para
          potencializar sua performance no campo. Auxiliando na correta
          distribuição nutritiva para a cultura, sem deixar de considerar todos
          os custos e maximizar seus ganhos.
        </p>
      </section>
      <footer className={Styles.footer}>
        <h3>Entraremos em contato!</h3>
        <Divider className={Styles.divider} />
        <p>
          Pronto para iniciar seu próximo projeto conosco? Isso é maravilhoso!
          Ligue para a gente ou envie um e-mail e iremos retornar o mais breve
          possível!
        </p>
        <div className={Styles.contactInfoContainer}>
          <a href='tel:+557136023056'>
            <Button color='transparent'>
              <FontAwesomeIcon icon={faPhone} />
              Candeias - +55 71 3602-3056
            </Button>
          </a>
          <a href='mailto:pemweb@sqm-vitas.com'>
            <Button color='transparent'>
              <FontAwesomeIcon icon={faEnvelope} />
              pemweb@sqm-vitas.com
            </Button>
          </a>
        </div>
        <p style={{ marginTop: '2rem' }}>
          SQM VITAS BRASIL © 2018 Todos os direitos reservados:
        </p>
        <Button color='transparent'>sqm-vitas.com</Button>
      </footer>
    </div>
  );
}
